import React from 'react';
import { Table, Badge, Dropdown } from 'react-bootstrap';

const LeadsBoard = () => {
  const leads = [
    { id: 1, name: 'Sam Walter', status: 'New Lead', company: 'Sunshine Limited' },
    { id: 2, name: 'Rajesh Chaturvedi', status: 'Contacted', company: 'ABC Corporation' },
    { id: 3, name: 'Shreya Vardhan', status: 'Follow up', company: 'Apple Inc.' },
  ];

  const getStatusColor = (status) => {
    switch (status) {
      case 'New Lead': return 'warning';
      case 'Contacted': return 'success';
      case 'Follow up': return 'info';
      default: return 'secondary';
    }
  };

  return (
    <div className="mb-4">
      <h6 className="fw-bold mb-3">Leads Board</h6>
      <Table bordered hover responsive>
        <thead>
          <tr>
            <th>S.NO</th>
            <th>Name</th>
            <th>Status</th>
            <th>Company</th>
          </tr>
        </thead>
        <tbody>
          {leads.map((lead, idx) => (
            <tr key={lead.id}>
              <td>{idx + 1}</td>
              <td>{lead.name}</td>
              <td>
                <Dropdown>
                  <Dropdown.Toggle variant={getStatusColor(lead.status)} size="sm">
                    {lead.status}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item>New Lead</Dropdown.Item>
                    <Dropdown.Item>Contacted</Dropdown.Item>
                    <Dropdown.Item>Follow up</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </td>
              <td>{lead.company}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default LeadsBoard;
